import { c as _c } from "react/compiler-runtime";
export default function RestassuredEcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M34.364 3C41.648 3 46 9.663 46 16.106c0 5.94-2.79 11.873-8.292 17.632a56.518 56.518 0 01-9.849 8.076A7.645 7.645 0 0123.886 43a6.611 6.611 0 01-3.533-1.045 56.636 56.636 0 01-10.06-8.215C4.79 27.98 2 22.047 2 16.107 2 9.664 6.352 3 13.636 3c3.555 0 6.319 1.672 8.697 5.261a2 2 0 003.334 0C28.045 4.671 30.808 3 34.364 3m0-2C29.544 1 26.344 3.616 24 7.154 21.656 3.617 18.456 1 13.636 1 5.462 1 0 8.15 0 16.107c0 7.466 3.98 13.92 8.846 19.014a59.31 59.31 0 0010.416 8.51A8.591 8.591 0 0023.886 45a9.655 9.655 0 005.076-1.516 59.113 59.113 0 0010.192-8.363C44.02 30.027 48 23.573 48 16.107 48 8.15 42.538 1 34.364 1z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg className={className} fill="currentColor" viewBox="0 0 48 46" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}